export default __webpack_public_path__ + "static/media/Process2.e85ba572.svg";